import React from 'react'
import { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'

class Menu extends Component {  
    hiddenClass = 'menu__list--hidden'

    constructor(props) {
        super(props)
        this.containerEl = document.createElement('div')
        this.containerEl.classList.add('menu__list')
        this.containerEl.classList.add(this.hiddenClass)
    }

    handleShow = (e) => {
        const box = e.target.getBoundingClientRect()

        const top = box.y ? box.y : box.top;
        const left = box.x ? box.x : box.left;

        this.containerEl.style.top = top + 'px'
        this.containerEl.style.left = left + 'px'
        this.containerEl.classList.remove(this.hiddenClass)

        const windowWidth = window && window.innerWidth
        const menuWidth = this.containerEl.getBoundingClientRect().width        

        if (left + menuWidth > windowWidth)
            this.containerEl.style.left = (windowWidth - menuWidth - 32) + 'px' // -32 for margin

        this.callback = this.handleHide()
        document.addEventListener("mousedown", this.callback)
    }

    handleHide = (callback) => (e) => {
        callback && callback()
        document.removeEventListener("mousedown", this.callback)
        setTimeout(() => this.containerEl.classList.add(this.hiddenClass), 300)
    }

    renderChild = (child) => {
        let { className, onClick } = child.props

        className = className ?
            className + ' menu__list__item' :
            'menu__list__item';

        onClick = this.handleHide(onClick)
        return React.cloneElement(child, { className, onClick })
    }

    render() {
        return (
            <Fragment>
                <span className="menu__handle" ref={this.containerElement} onClick={this.handleShow}>
                    {this.props.handle}
                </span>
                { ReactDOM.createPortal(
                    React.Children.map(this.props.children, this.renderChild),
                    this.containerEl) }
            </Fragment>
        )
    }

    componentDidMount() {
        document.body.appendChild(this.containerEl)
    }

    componentWillUnmount() {
        document.body.removeChild(this.containerEl)
    }
}

export default Menu